import React, { useState, useEffect, useRef, useCallback } from "react";
import "../src/assets/components/visitorregistry.css";
import { useNavigate } from "react-router-dom";
import AutoLogout from "./autologout";
import Webcam from "react-webcam";
import Swal from "sweetalert2";

function Visitorregistry() {
  const [firstname, setFirstname] = useState("");
  const [middlename, setMiddlename] = useState("");
  const [lastname, setLastname] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [cellnumber, setCellnumber] = useState("");
  const [residenceof, setResidenceof] = useState("");
  const [referenceperson1, setReferenceperson1] = useState("");
  const [referenceperson2, setReferenceperson2] = useState("");
  const [currentDate, setCurrentDate] = useState();
  const navigate = useNavigate();
  const [photo, setPhoto] = useState(""); // State for storing the captured photo
  const [hasCamera, setHasCamera] = useState(false);
  const [cameraDeviceId, setCameraDeviceId] = useState(null);
  const [photoTaken, setPhotoTaken] = useState(false);
  const [isCameraVisible, setIsCameraVisible] = useState(true);

  const webcamRef = useRef(null);

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setPhoto(imageSrc);
    setPhotoTaken(true);
  }, [webcamRef]);

  const retakePhoto = useCallback(() => {
    setPhoto("");
    setPhotoTaken(false);
  }, []);

  useEffect(() => {
    // Function to update date and time
    const updateDateTime = () => {
      const now = new Date();
      const dateOptions = { year: "numeric", month: "long", day: "numeric" };

      setCurrentDate(now.toLocaleDateString(undefined, dateOptions));
    };

    // Check camera availability
    const checkCamera = async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );

        if (videoDevices.length > 0) {
          setHasCamera(true);
          setCameraDeviceId(videoDevices[0].deviceId); // Use the first available camera
        } else {
          setHasCamera(false);
        }
      } catch (error) {
        console.error("Error checking camera availability:", error);
      }
    };

    checkCamera();
    updateDateTime();

    // Update date and time every second
    const intervalId = setInterval(updateDateTime, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array means this effect runs once after the initial render

  const handleSave = (event) => {
    event.preventDefault();

    if (!photoTaken) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please take a photo!",
      });
      return;
    }
    const userData = {
      firstname,
      middlename,
      lastname,
      age,
      gender,
      cellnumber,
      currentDate,
      residenceof,
      referenceperson1,
      referenceperson2,
      dateIn: currentDate,
      photo,
    };
    console.log("Sending data to server:", userData);

    // Make a POST request to the server to handle registration
    fetch("https://brgytracerappserver.onrender.com/visitorregistry", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    })
      .then((response) => response.json())
      .then((data) => {
        // Handle the response from the server
        console.log(data);
        if (data.status === "success") {
          Swal.fire({
            icon: "success",
            title: "Successfully Registered!",
            showConfirmButton: true,
          }).then(() => {
            // Refresh the page after the user clicks "Okay"
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Registration Failed!",
            text: data.message,
          });
        }
        // Redirect or show a success message based on the response
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle errors
        Swal.fire({
          icon: "error",
          title: "System Error!",
          text: "Please try again later.",
        });
      });
  };

  const showcamera = () => {
    setIsCameraVisible(!isCameraVisible);
  };

  const hidecamera = () => {
    setIsCameraVisible(true);
  };

  const handleclose = () => {
    navigate("/officerpage");
  };

  return (
    <div className="visitor-registry parent-height">
      <AutoLogout />
      <div className="VisitorRegistry-parent-container">
        <div className="form-holder">
          <h1>Visitor Registry</h1>
          <form className="VisitorRegistry-parent showcamera">
            <div
              className={`camera-holder ${isCameraVisible ? "hide-it" : ""}`}>
              <div className="webcam-container">
                {photoTaken ? (
                  <div className="photo-preview">
                    <img src={photo} alt="Captured" />
                  </div>
                ) : (
                  <div
                    className={
                      hasCamera
                        ? "webcam-holder"
                        : "webcam-holder no-camera-detected"
                    }>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/jpeg"
                      width={300}
                      height={300}
                      videoConstraints={{ deviceId: cameraDeviceId }}
                    />
                  </div>
                )}
                <div>
                  {photoTaken ? (
                    <div className="buttons-container">
                      <button
                        type="button"
                        onClick={retakePhoto}
                        disabled={!hasCamera}
                        className="button-retake">
                        Retake
                      </button>
                      <button
                        type="button"
                        className="hidden-camera"
                        onClick={hidecamera}>
                        Hide
                      </button>
                    </div>
                  ) : (
                    <div className="buttons-container">
                      <button
                        type="button"
                        onClick={capturePhoto}
                        disabled={!hasCamera}
                        className="button-capture">
                        Capture
                      </button>
                      <button
                        type="button"
                        className="hidden-camera"
                        onClick={hidecamera}>
                        Hide
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="VisitorRegistry-box-holder">
              <div>
                <label htmlFor="firstname">First name:</label>
                <input
                  type="text"
                  required
                  onChange={(e) => setFirstname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="middlename">Middle Name:</label>
                <input
                  type="text"
                  required
                  onChange={(e) => setMiddlename(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="lastname">Last Name:</label>
                <input
                  type="text"
                  required
                  onChange={(e) => setLastname(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="age">Age:</label>
                <input
                  type="text"
                  required
                  min="0" // Specify minimum age
                  maxLength={3} // Set the maximum length to 3
                  pattern="[0-9]*" // Allow only numeric values
                  onKeyPress={(e) => {
                    // Allow only numeric characters and the Enter key
                    if (isNaN(e.key) && e.key !== "Enter") {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    // Remove non-numeric characters
                    const numericValue = e.target.value.replace(/[^0-9]/g, "");

                    // Update the state with the numeric value
                    setAge(numericValue);
                  }}
                />
              </div>
              <div>
                <label htmlFor="Gender">Gender:</label>
                <select
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}>
                  <option value="Not Set">Not Set</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
              <div>
                <label htmlFor="phoneNumber">Contact Number:</label>
                <input
                  type="text"
                  required
                  pattern="[0-9]{4} [0-9]{3} [0-9]{4}"
                  value={cellnumber}
                  onChange={(e) => {
                    const formattedValue = e.target.value.replace(
                      /[^0-9 ]/g,
                      ""
                    );

                    // Update the state with the formatted value
                    setCellnumber(formattedValue);
                  }}
                />
                <small>Format: 0000 000 0000</small>
              </div>
              <div>
                <label htmlFor="residenceof">Current Residence:</label>
                <input
                  type="text"
                  required
                  onChange={(e) => setResidenceof(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="referenceperson1">Reference Person 1:</label>
                <input
                  type="text"
                  required
                  onChange={(e) => setReferenceperson1(e.target.value)}
                />
              </div>
              <div>
                <label htmlFor="referenceperson2">Reference Person 2:</label>
                <input
                  type="text"
                  onChange={(e) => setReferenceperson2(e.target.value)}
                />
              </div>
            </div>
            <button className="registerbtn" onClick={handleSave}>
              Register
            </button>

            <div className="isshowcamera" onClick={showcamera}></div>
          </form>
          <button
            type="button"
            className="closebtn"
            onClick={handleclose} //close the page and back to login page
          >
            X
          </button>
        </div>
      </div>
    </div>
  );
}

export default Visitorregistry;
